// 基准大小
const baseSize = 16
// 设计稿宽度
const designWidth = 1920

// 设置 rem 函数
function setRem () {
    const clientWidth = document.documentElement.clientWidth
    let fontSize = baseSize
    
    // 全尺寸响应式适配
    if (clientWidth <= 768) {
        // 移动端：按比例缩放，但设置最小值防止字体过小
        const mobileScale = clientWidth / 375 // 以375px为移动端基准
        fontSize = Math.max(baseSize * mobileScale, 12) // 最小12px
    } else if (clientWidth <= 1024) {
        // 平板端：按比例缩放
        const tabletScale = clientWidth / 768
        fontSize = baseSize * tabletScale
    } else if (clientWidth <= 1366) {
        // 小屏幕PC：稍微调整，避免字体过大
        fontSize = baseSize * 0.9
    } else if (clientWidth <= 1920) {
        // 标准屏幕：线性缩放
        fontSize = baseSize * (clientWidth / designWidth)
    } else {
        // 大屏幕：缩放，但设置上限
        fontSize = baseSize * Math.min(clientWidth / designWidth, 1.5) // 最大1.5倍
    }
    
    // 设置根元素字体大小
    document.documentElement.style.fontSize = fontSize + 'px'
}

// 初始化
setRem()

// 改变窗口大小时重新设置 rem
window.addEventListener('resize', function () {
    // 使用防抖优化性能
    clearTimeout(window.remTimer)
    window.remTimer = setTimeout(setRem, 50)
})

// 监听设备方向变化（针对移动设备）
window.addEventListener('orientationchange', setRem)

// 页面加载完成后再执行一次，确保初始计算准确
window.addEventListener('load', setRem)
